import Vue from 'vue'
import store from './store'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
// you can set only in production env show the error-log
// if (process.env.NODE_ENV === 'production') {
  // if (process.env.NODE_ENV === 'development') {
  Vue.config.errorHandler = function(err, vm, info) {
    // Don't ask me why I use Vue.nextTick, it just a hack.
    // detail see https://forum.vuejs.org/t/dispatch-in-vue-config-errorhandler-has-some-problem/23500
    Vue.nextTick(() => {
      store.dispatch('addErrorLog', {
        err,
        vm,
        info,
        url: window.location.href
      })
    })
  }
  // sentry 第三方错误报告平台
  Raven.config('https://51c7cd6247b741efab29b4ca5d9ec6bf@sentry.xiaoniren.cn/4')
    .addPlugin(RavenVue, Vue)
    .install()
// }



// WEBPACK FOOTER //
// ./src/errorLog.js